import React, {useCallback, useMemo, useState} from "react";
import useIsMounted from "../../../../../../../hooks/use-is-mounted";
import Api from "../../../../../../../../core/services/api/api";
import PartAutocomplete from "../../../../../../../components/text-fields/autocomplete/part-autocomplete";


const CompareViewPartsAutoComplete = ({onPartAdded, currentlySelectedParts, onExistingPartSelected}) => {
    const [adding, setAdding] = useState(false);
    const isMounted = useIsMounted();

    /**
     * Memo version of selected part Ids
     * @type {number[]}
     */
    const selectedPartIds = useMemo(() => currentlySelectedParts?.map(e => e.id) ?? [], [currentlySelectedParts]);

    /**
     * Adds the given part to the current comparison list of the user.
     */
    const addToCompareList = useCallback(async (e, part) => {
        if (selectedPartIds.includes(part.id)) {
            onExistingPartSelected(part);
            return;
        }
        setAdding(true);
        const response = await Api.addPartToCompareList({
            partId: part.id,
        });
        if (!isMounted())
            return;
        setAdding(false);
        if (response?.resultFlag) {
            onPartAdded(part);
        }
    }, [selectedPartIds, isMounted, onExistingPartSelected, onPartAdded]);

    return (
        <PartAutocomplete
            label={'Add part to compare'}
            textFieldProps={{
                label: 'Add part to compare',
                variant: 'filled',
                InputProps: {
                    disableUnderline: true,
                },
            }}
            disabled={adding}
            onChange={addToCompareList}
            getOptionLabel={o => o?.partNumber ?? o?.partNo ?? ''}
        />
    );
}

export default CompareViewPartsAutoComplete;
